import React from 'react';
export function ResultShowcase() {
  const images = [{
    url: 'https://images.unsplash.com/photo-1601056639638-55363d4d471c?q=80&w=1000&auto=format&fit=crop',
    label: 'Crystal Clear Jewelry'
  }, {
    url: 'https://images.unsplash.com/photo-1615655406736-b37c4fabf923?q=80&w=1000&auto=format&fit=crop',
    label: 'Glossy Trays'
  }, {
    url: 'https://images.unsplash.com/photo-1598532163257-ae3c6b2524b6?q=80&w=1000&auto=format&fit=crop',
    label: 'Botanical Coasters'
  }, {
    url: 'https://images.unsplash.com/photo-1611085583191-a3b181a88401?q=80&w=1000&auto=format&fit=crop',
    label: 'Ocean Art'
  }, {
    url: 'https://images.unsplash.com/photo-1605152276897-4f618f831968?q=80&w=1000&auto=format&fit=crop',
    label: 'Flawless Finish'
  }];
  return <section className="py-16 bg-white border-y border-stone-100" data-id="element-114">
      <div className="container mx-auto px-4 mb-10 text-center" data-id="element-115">
        <h2 className="text-3xl md:text-4xl font-bold text-stone-900" data-id="element-116">
          See What You Can Create With The Right System
        </h2>
      </div>

      <div className="relative w-full overflow-hidden" data-id="element-117">
        <div className="flex overflow-x-auto gap-6 px-4 pb-8 hide-scrollbar snap-x snap-mandatory max-w-7xl mx-auto" data-id="element-118">
          {images.map((img, idx) => <div key={idx} className="flex-shrink-0 w-[280px] md:w-[350px] snap-center group relative rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300" data-id="element-119">
              <div className="aspect-[4/5] bg-stone-200" data-id="element-120">
                <img src={img.url} alt={img.label} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-121" />
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-4 bg-gradient-to-t from-black/60 to-transparent" data-id="element-122">
                <p className="text-white font-medium text-lg" data-id="element-123">{img.label}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}